module.exports = __webpack_public_path__ + "static/media/my-login.babcc96f.svg";